<app-modal
  [title]="'Kassenbestand' | trans:'safes/safe-actions-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="safe-actions-buttons-wrapper d-grid gap-12">
      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
        [extraDisabled]="isReservationTerminal || isTerminalWithoutSafe"
        (click)="cashInOutModalComponent.open({ type: 'in' })"
      >
        <i class="ri-login-circle-line"></i>
        {{ 'Deposit' | trans:'safes/safe-actions-modal/buttons/deposit.Button' }}
      </button>

      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
        [extraDisabled]="isReservationTerminal || isTerminalWithoutSafe"
        (click)="cashInOutModalComponent.open({ type: 'out' })"
      >
        <i class="ri-logout-circle-r-line"></i>
        {{ 'Withdraw' | trans:'safes/safe-actions-modal/buttons/withdraw.Button' }}
      </button>

      <button
        class="button button--quick-action"
        [appWebCashPermissionControl]="permissionKeys.WebCxCashSafes"
        [extraDisabled]="!terminalParametersMap()[terminalParameterKeys.CSH_SAFE_PORT] || isTerminalWithoutSafe"
        (click)="openSafe()"
      >
        <i class="ri-coin-line"></i>
        {{ 'Open Cashdrawer' | trans:'safes/safe-actions-modal/buttons/open-cash-drawer.Button' }}
      </button>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel' | trans:'safes/safe-actions-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-cash-in-out-modal #cashInOutModalComponent />
